  @if (!hosted) {
    <app-home-button [tags]="tags"></app-home-button>
  }
@if (ready) {
  <!-- HEADER START -->
  @if (displayHeader) {
    @switch (headerType) {
      @case ('full') {
        <app-full-page-image-header
          [title]="title"
          [description]="description"
          [topics]="topics"
          [headerImage]="headerImage"
        ></app-full-page-image-header>
      }
      @case ('title_only') {
        <div
          class="{{ widthClass }} header title-only"
          >
          <h1 [innerHTML]="title"></h1>
        </div>
      }
      @case ('short') {
        <div
          class="header short"
          [ngStyle]="getHeaderBackground()"
          >
          <h1 [innerHTML]="title"></h1>
          <p [innerHTML]="description"></p>
          @if (topicOverride) {
            <app-subscribe-dialog
              [selectedTopics]="[topicOverride]"
            ></app-subscribe-dialog>
          }
        </div>
      }
      @case ('campaign') {
        <div class="header campaign {{ title }}">
          <h1 [innerHTML]="title"></h1>
          <img [src]="headerImage" [alt]="title" />
          <app-subscribe-dialog [selectedTopics]="[title]"></app-subscribe-dialog>
          <a [href]="getCampaignLink()">
            <button mat-flat-button class="campaign-link">
              {{ getCampaignTitle() }}
            </button>
          </a>
        </div>
      }
      @case ('journalistic') {
        <div
          class="journalistic-header {{ widthClass }}"
          >
          <h1 [innerHTML]="title"></h1>
          @if (subtitle) {
            <div class="subtitle" [innerHTML]="subtitle"></div>
          }
          <hr />
          <div class="attribution">
            <div class="text">
              @if (byline) {
                <div class="byline">By {{ byline }}</div>
              }
              <div>{{ date }} / KNOWLEDGE EXCHANGE</div>
            </div>
            @if (title) {
              <app-social-links
                [title]="title"
                position="right"
              ></app-social-links>
            }
          </div>
          <img class="header-img" src="{{ headerImage }}" />
        </div>
      }
      @case ('hero') {
        <div class="header hero {{ widthClass }}">
          <div class="header-img-container">
            <img class="header-img" src="{{ headerImage }}" />
          </div>
          <div class="description">
            @if (mobile) {
              <h1 class="title">{{ title }}</h1>
            } @else {
              <h1 class="title split">{{ splitTitle[0] }}</h1>
              <h1 class="title split">{{ splitTitle[1] }}</h1>
            }
            <h2 class="subtitle">{{ subtitle }}</h2>
          </div>
        </div>
      }
      @default {
        <p>Invalid header option.</p>
      }
    }
  }
  <!-- HEADER END -->
  @if (showHeroCarouselHeader) {
    <div>
      <app-hero-swiper
        [entryRegistation]="heroEntryRegistration"
        [entryClicked]="heroEntryClicked"
      ></app-hero-swiper>
    </div>
  }
  <!-- CONTENT START -->
  <div class="custom-page {{ widthClass }}">
    @for (s of sections; track s) {
      <app-custom-page-section
        [sectionData]="s"
        [parentNodeId]="nodeID"
      ></app-custom-page-section>
    }
  </div>
  @if (!hosted) {
    <app-contributor-list [people]="contributors"></app-contributor-list>
  }
  <!-- CONTENT END -->
  <!-- <app-reactions></app-reactions> -->
} @else {
  <div class="page-loading-center">
    <app-loading-indicator></app-loading-indicator>
  </div>
}
